export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

export const DEKADS = [
  { name: "1", value: '1' },
  { name: "2", value: '2' },
  { name: "3", value: '3' },
] as const;
